import { Text } from "@radix-ui/themes";

import { CanvasBlockRenderer } from "../CanvasBlockRenderer";

import type { CanvasBlock } from "../types";

interface SectionBlockProps {
  id: string;
  title: string;
  editable?: boolean;
  children: CanvasBlock[];
}

export function SectionBlock({ id, title, children }: SectionBlockProps) {
  return (
    <div id={`canvas-section-${id}`} className="space-y-2">
      <Text as="p" size="3" weight="bold" className="text-puntt-neutral-gray-12">
        {title}
      </Text>
      <div className="space-y-2 pl-1">
        {children.map((child, idx) => (
          <CanvasBlockRenderer key={idx} block={child} />
        ))}
      </div>
    </div>
  );
}
